<template>
  <van-swipe class="slide" :autoplay="3000" lazy-render>
    <van-swipe-item
      v-for="slide in slideList"
      :key="slide"
      @click="onClick(slide.url)"
    >
      <van-image width="100%" height="100%" :src="slide.img" />
    </van-swipe-item>
    <template #indicator="{ active, total }">
      <div class="slide-bottom-container">
        <div class="title van-ellipsis">{{ getTitle(active) }}</div>
        <div class="custom-indicator">
          <div
            :class="active == index - 1 ? 'bot-active' : 'bot'"
            v-for="index in total"
            :key="index"
          ></div>
        </div>
      </div>
    </template>
  </van-swipe>
</template>

<script>
import { Swipe, SwipeItem, Image as VanImage, List } from "vant";
export default {
  name: "Slide",
  props: {
    slideList: List,
  },
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [VanImage.name]: VanImage,
  },
  setup(props) {
    const onClick = (url) => {
      window.open(url, "_blank");
    };
    const getTitle = (index) => {
      if (index >= 0 && index < props.slideList.length)
        return props.slideList[index].title;
    };
    return { onClick, getTitle };
  },
};
</script>

<style lang="scss" scoped>
.slide-bottom-container {
  background-color: rgba($color: #000000, $alpha: 0.6);
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  right: 0px;
  bottom: 0px;
  width: 100%;
  height: 8vw;
}
.title {
  font-size: 4.53vw;
  color: white;
  margin-left: 10px;
}
.custom-indicator {
  font-size: 12px;
  display: flex;
  align-items: center;
  height: 100%;
  margin: 0 10px;
  .bot {
    width: 4px;
    height: 4px;
    background-color: white;
    border-radius: 2px;
    margin-right: 10px;
  }
  .bot-active {
    width: 4px;
    height: 4px;
    background-color: red;
    border-radius: 2px;
    margin-right: 10px;
  }
}
</style>
